import React from 'react';

/* Оборачивает последовательности цифр в Bebas Neue (1.02em) — она дополняет
   фирменный Saar SP Demo так, что смотрится как один шрифт (как в дизайне
   «Домашка ученика»). Класс .nhw-bebas задаёт сам шрифт/размер. */
export function bebasDigits(text) {
  if (text == null) return text;
  // Группируем «№» вместе с цифрами, чтобы значок номера смотрелся как единый шрифт с числом.
  return String(text).split(/(№?\d+)/).map((p, i) =>
    /^№?\d+$/.test(p) ? <span key={i} className="nhw-bebas">{p}</span> : p
  );
}
